const {
  VITE_API_URL,
  VITE_API_KEY,
  VITE_AUTH_URL,
  VITE_SENTRY_DSN,
  VITE_AUTH_SCOPE,
  VITE_LOGOUT_URL,
  VITE_GA_GTAG_ID,
  VITE_CLARITY_ID,
  VITE_SUPPORT_LINK,
  VITE_AUTH_CLIENT_ID,
  VITE_WORKFLOW_LINK,
  VITE_FLIPT_URL,
  VITE_FLIPT_NAMESPACE,
  VITE_FLIPT_TOKEN,
  VITE_FLIPT_API_URL,
} = import.meta.env;

export const appEnv = {
  apiUrl: VITE_API_URL,
  apiKey: VITE_API_KEY,
  authUrl: VITE_AUTH_URL,
  fliptUrl: VITE_FLIPT_URL,
  logoutUrl: VITE_LOGOUT_URL,
  clarityId: VITE_CLARITY_ID,
  authScope: VITE_AUTH_SCOPE,
  sentryDSN: VITE_SENTRY_DSN,
  analyticsId: VITE_GA_GTAG_ID,
  supportUrl: VITE_SUPPORT_LINK,
  workflowUrl: VITE_WORKFLOW_LINK,
  authClientId: VITE_AUTH_CLIENT_ID,
  fliptNamespace: VITE_FLIPT_NAMESPACE,
  fliptToken: VITE_FLIPT_TOKEN,
  fliptApiUrl: VITE_FLIPT_API_URL,
};
